module.exports = __webpack_public_path__ + "static/media/moth-home.2b8ad043.mp4";